/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import '../css/components/EnvironmentBanner.css';

const ENV_BANNER: Record<string, { label: string; color: string }> = {
  dev: { label: 'DEV', color: 'var(--env-dev)' },
  stag: { label: 'STAGING', color: 'var(--env-staging)' },
  stagsafe: { label: 'STAGING SAFE', color: 'var(--env-staging)' },
  uat1: { label: 'UAT1', color: 'var(--env-uat)' },
  du: { label: 'DU', color: 'var(--env-uat)' },
};

const EnvironmentBanner = () => {
  const env = process.env.REACT_APP_INSTANCE ?? '';
  const banner = ENV_BANNER[env];

  if (!banner) return null;

  return (
    <div className='env-banner' style={{ background: banner.color }}>
      {banner.label} ENVIRONMENT
    </div>
  );
};

export default EnvironmentBanner;
